<!-- hospital.component.html -->
<p-toast></p-toast>

<div class="card">
    <h2>Registro de puntos</h2>

    <form [formGroup]="catalogoForm" (ngSubmit)="onSubmit()">
        <div class="p-fluid p-formgrid p-grid">

            <!-- Nombre Hospital -->
            <div class="p-field p-col-12 p-md-6">
                <label for="descripcon">Puntos</label>
                <p-inputNumber id="puntos" formControlName="puntos" mode="decimal" class="w-full"
                    [ngClass]="{'ng-invalid ng-dirty': f['puntos'].touched && f['puntos'].errors}">
                </p-inputNumber>
                <small class="p-error" *ngIf="f['puntos'].touched && f['puntos'].errors?.['required']">
                    Los puntos son requeridos
                </small>

            </div>

        </div>
        <!-- Botones -->
        <div class="field col-12 md:col-4">
            <p-button type="submit" label="Guardar" icon="pi pi-save" [disabled]="catalogoForm.invalid">
            </p-button>
        </div>

    </form>
</div>